/* eslint-disable react-refresh/only-export-components */
import { FC, lazy, LazyExoticComponent } from 'react';

import { routingConfig } from '../../consts';
import { RouteWithComponent } from '../../interfaces';

const ProfileDetails: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('./components/profileDetails/profileDetails.component')
);
const ProfileEdit: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('./components/profileEdit/profileEdit.component')
);
const AgreementsTab: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('./components/agreementsTab/agreementsTab.component')
);
const CookiesTab: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('./components/cookiesTab/cookiesTab.component')
);
const PasswordsTab: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('./components/passwordsTab/passwordsTab.component')
);
const FacsimileTab: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('./components/facsimileTab/facsimileTab.component')
);
const DocumentsTab: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('./components/documentsTab/documentsTab.component')
);

export const profileRoutes: RouteWithComponent[] = [
  { pathSettings: routingConfig.profile.children.profileDetails, component: ProfileDetails },
  { pathSettings: routingConfig.profile.children.profileEdit, component: ProfileEdit },
  { pathSettings: routingConfig.profile.children.profileAgreements, component: AgreementsTab },
  { pathSettings: routingConfig.profile.children.profileCookies, component: CookiesTab },
  { pathSettings: routingConfig.profile.children.profilePasswords, component: PasswordsTab },
  { pathSettings: routingConfig.profile.children.profileFacsimile, component: FacsimileTab },
  { pathSettings: routingConfig.profile.children.profileDocuments, component: DocumentsTab },
];
